import React from 'react';
import { useSearchParams } from 'react-router-dom';
import FilterSelect from '../../../shared/FilterSelect';
import { Button } from '@mui/material';
import { locationPreferenceOptions } from 'shared-utils';
import { Badge, Label } from 'flowbite-react';
import Select from 'react-select';

export let locationPreferenceOptionsData = locationPreferenceOptions.map(location => ({
	value: location,
	label: location,
}));

const LocationFilterInput = ({ showSelect = false }: { showSelect?: boolean }) => {
	const [searchParams, setSearchParams] = useSearchParams();
	const location = JSON.parse(searchParams.get('location') || '[]');

	const options = locationPreferenceOptionsData;

	return (
		<>
			{!showSelect ? (
				<FilterSelect
					arrow={false}
					active={!!location?.length}
					placeholder={'Location'}
					onClose={() => {}}
					anchorOrigin={{
						vertical: 'bottom',
						horizontal: 'left',
					}}
					transformOrigin={{
						vertical: 'top',
						horizontal: 'left',
					}}
				>
					{({ handlePopoverClose }) => (
						<div className="min-w-[255px] bg-white dark:bg-[#1F2A37] py-2 ml-auto">
							{options?.map((option, index) => (
								<Button
									key={option?.value + index}
									sx={{
										textAlign: 'left',
										display: 'block',
										py: '8px',
										width: '100%',
										px: '18px',
										fontSize: '14px',
										fontWeight: '400',
										color: 'inherit',
										borderRadius: '0',
										textTransform: 'none',
										'&:hover': { backgroundColor: '#7777e73f' },
										backgroundColor: location?.includes(option?.value?.toString()) ? '#7777e71b' : 'transparent',
									}}
									onClick={() => {
										// if (handlePopoverClose) handlePopoverClose();
										if (location?.includes(option?.value?.toString())) {
											searchParams.set(
												'location',
												JSON.stringify(location?.filter((skill: string) => skill !== option?.value?.toString())),
											);
											setSearchParams(searchParams);
											return;
										}
										searchParams.set('location', JSON.stringify([...location, option?.value?.toString()]));
										setSearchParams(searchParams);
									}}
								>
									{option?.label}
									{location?.includes(option?.value?.toString()) ? (
										<Badge className="rounded-[6px] font-[500] text-xs inline-flex w-fit ml-1" size="xs" color="dark">
											Selected
										</Badge>
									) : null}
								</Button>
							))}
						</div>
					)}
				</FilterSelect>
			) : (
				<div>
					<Label className="mb-1 inline-block">Location</Label>
					<Select
						isMulti
						menuPosition="fixed"
						placeholder="Bangalore"
						className="flowbite-select--md"
						classNamePrefix="flowbite-select"
						options={locationPreferenceOptionsData}
						value={locationPreferenceOptionsData?.filter(option => location?.includes(option?.value?.toString()))}
						onChange={option => {
							searchParams.set('location', JSON.stringify(option?.map((option: any) => option?.value?.toString())));
							setSearchParams(searchParams);
						}}
					/>
				</div>
			)}
		</>
	);
};

export default LocationFilterInput;
